'use client';

import { useState, type ReactNode } from 'react';

const STORAGE_KEY = 'locale-transition-pending';

function consumePendingTransition(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  const pending = sessionStorage.getItem(STORAGE_KEY);
  if (pending) {
    sessionStorage.removeItem(STORAGE_KEY);
    return true;
  }
  return false;
}

export function markLocaleTransition() {
  sessionStorage.setItem(STORAGE_KEY, '1');
}

export function LocaleTransition({ children }: { children: ReactNode }) {
  const [animating, setAnimating] = useState(consumePendingTransition);

  return (
    <div
      className={animating ? 'animate-locale-switch' : undefined}
      onAnimationEnd={() => setAnimating(false)}
    >
      {children}
    </div>
  );
}
